import { collection, onSnapshot, doc, addDoc, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "@/fb.js";
import { config } from "@/utils/configuration/config";
import { getErrorMessageFromFirebaseError } from "@/utils/utils";

export default class ShipRepoFirebase {
  async getShips(ships, service) {
    console.log("ShipRepoFirebase-getShips from", config.firebaseConfig.shipsCollectionName);
    onSnapshot(collection(db, config.firebaseConfig.shipsCollectionName), (querySnapshot) => {
      const changes = querySnapshot.docChanges();

      changes.forEach(async (change) => {
        console.log("ShipRepoFirebase-getShips. Change = ", change);
        if (change.type === "added") {
          service.addNewShipFromRepo(ships, change.doc.id, change.doc.data());
        } else if (change.type === "modified") {
          service.modifyShipFromRepo(ships, change.doc.id, change.doc.data());
        } else if (change.type === "removed") {
          service.removeShipFromRepo(ships, change.doc.id);
        }
      });
    });
  }

  editShip(shipId, ship) {
    console.log("ShipRepoFirebase-editShip", shipId, ship);

    const shipRef = doc(db, config.firebaseConfig.shipsCollectionName, shipId);

    var errors = "";
    try {
      setDoc(shipRef, ship);
    } catch (error) {
      console.log("Error", error);
      errors = getErrorMessageFromFirebaseError(error);
    }

    console.log("ShipRepoFirebase-editShip fin");
    return errors;
  }

  saveNewShip(ship) {
    console.log("ShipRepoFirebase-saveNewShip", ship);

    var errors = "";
    try {
      addDoc(collection(db, config.firebaseConfig.shipsCollectionName), ship);
    } catch (error) {
      console.log("Error", error);
      errors = getErrorMessageFromFirebaseError(error);
    }

    return errors;
  }

  deleteShip(shipId) {
    const shipRef = doc(db, config.firebaseConfig.shipsCollectionName, shipId);
    deleteDoc(shipRef);
  }
}
